import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import logoIcon from '../assets/logo-icon.png';
import './PageLoader.css';

export const PageLoader = ({ onDone }) => {
  const reduced = useReducedMotion();
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (reduced) { onDone(); return; }
    const t = setTimeout(() => {
      setExiting(true);
      setTimeout(onDone, 480);
    }, 1800);
    return () => clearTimeout(t);
  }, [onDone, reduced]);

  return (
    <motion.div
      className="page-loader"
      animate={{ opacity: exiting ? 0 : 1 }}
      transition={{ duration: 0.48, ease: [0.16, 1, 0.3, 1] }}
    >
      {/* Teal glow behind logo */}
      <motion.div
        className="loader-glow"
        animate={reduced ? {} : { opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2.6, repeat: Infinity, ease: 'easeInOut' }}
        aria-hidden="true"
      />

      {/* Floating logo wrapper */}
      <motion.div
        className="loader-float"
        animate={reduced ? {} : { y: [0, -14, 0] }}
        transition={{ duration: 2.6, repeat: Infinity, ease: 'easeInOut', delay: 0.3 }}
      >
        <motion.img
          src={logoIcon}
          alt="Liceron"
          className="loader-logo-img"
          initial={{ opacity: 0, scale: 0.78 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
        />
      </motion.div>

      {/* Wordmark */}
      <motion.span
        className="loader-wordmark"
        initial={{ opacity: 0, y: reduced ? 0 : 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.22, ease: [0.16, 1, 0.3, 1] }}
      >
        LICERON
      </motion.span>

      {/* Bottom progress bar */}
      <div className="loader-bar-track">
        <motion.div
          className="loader-bar-fill"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.5, delay: 0.25, ease: [0.25, 1, 0.5, 1] }}
        />
      </div>
    </motion.div>
  );
};
